import { createSelector } from "reselect";
import { IGianniTattooStore } from "./GianniTattooStore";

const getGianniTattooState = (state: IGianniTattooStore) => state;

export const getCurrentMenu = createSelector(
  getGianniTattooState,
  (state) => state.currentMenu
);
